import { Trans, useLingui } from "@lingui/react/macro";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import { Heading } from "@medoma/components/Heading/Heading";
import { patientStatusSchema, type IPatient } from "@medoma/models/patients";
import { useParentRoutesPatient } from "@/api/Patients";
import { AdmitPatientForm } from "@/forms/RegisterPatientForm/AdmitPatientForm";
import styles from "./AdmitPatient.module.scss";

export const AdmitPatient = ({ patient }: { patient: IPatient }) => {
  const { t } = useLingui();

  return (
    <section className={styles.admitPatient}>
      <Heading level="h2">
        <Trans>Fullfölj inskrivning</Trans>
      </Heading>
      {patient.status === patientStatusSchema.enum.prospect ? (
        <AdmitPatientForm patient={patient} />
      ) : (
        <ErrorMessage
          message={t`Patienten är inte under bedömning och kan därför inte skrivas in.`}
        />
      )}
    </section>
  );
};

export const AdmitParentRoutesPatient = () => (
  <AdmitPatient patient={useParentRoutesPatient()} />
);
